import { IntlShape } from 'react-intl';

export const dictionary = {
    purchases_page_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.b4b5e091be238ed9df46d35b241611bc',
            defaultMessage: 'Purchases',
            description: 'Заголовок для страницы покупок',
        }),
    purchases_empty_button: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.7b19b37e7fc3dfe3c3e1ad5b84c7f565',
            defaultMessage: 'Home page',
            description: 'Кнопка для пустого списка покупок',
        }),
    purchases_empty_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.b8a2c3facb07606a6efdc6e657e61484',
            defaultMessage: "You haven't bought anything",
            description: 'Заголовок для пустого списка покупок',
        }),
    purchases_empty_icon_alt: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.be419ed2ceeb3766b3c186b2894550ac',
            defaultMessage: 'Icon for the empty Purchases',
            description: 'Текст для иконки пустого списка покупок',
        }),
    purchases_selection_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.selection.title',
            defaultMessage: 'Purchases',
            description: 'Заголовок для списка покупок',
        }),
    purchases__this_month: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.this_month',
            defaultMessage: 'This month',
            description: 'Этот месяц',
        }),
    purchases__last_3_months: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.last_3_months',
            defaultMessage: 'Last 3 months',
            description: 'Последние 3 месяца',
        }),
    purchases__last_6_months: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.last_6_months',
            defaultMessage: 'Last 6 months',
            description: 'Последние 6 месяцев',
        }),
    purchases__last_year: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'scenarios.purchases.i18n.last_year',
            defaultMessage: 'Last year',
            description: 'Последний год',
        }),
};
